document.addEventListener('DOMContentLoaded',()=>{
  const body=document.body;

  // Mobile navigation
  const menuBtn=document.querySelector('[data-menu-toggle]');
  const nav=document.querySelector('[data-mobile-nav]');
  if(menuBtn&&nav){
    menuBtn.addEventListener('click',()=>{
      const open=nav.classList.toggle('is-open');
      menuBtn.setAttribute('aria-expanded',String(open));
    });
  }

  // FAQ accordion
  document.querySelectorAll('[data-faq]').forEach(item=>{
    const btn=item.querySelector('.faq-q');
    if(btn){
      btn.setAttribute('aria-expanded','false');
      btn.addEventListener('click',()=>{
        const open=item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded',String(open));
      });
    }
  });

  // Schedule modal
  const modal=document.querySelector('[data-schedule-modal]');
  document.querySelectorAll('[data-open-schedule]').forEach(btn=>btn.addEventListener('click',e=>{
    e.preventDefault();
    if(modal) modal.classList.add('is-open');
  }));
  if(modal){
    modal.addEventListener('click',e=>{if(e.target===modal) modal.classList.remove('is-open')});
    modal.querySelectorAll('[data-close-modal]').forEach(btn=>btn.addEventListener('click',()=>modal.classList.remove('is-open')));
    document.addEventListener('keydown',e=>{if(e.key==='Escape') modal.classList.remove('is-open')});
  }

  // Add premium motion classes to existing editable sections.
  const revealSelectors=[
    '.section-heading-row','.pricing-intro','.pricing-shell','.split-media','.split-copy',
    '.feature-card','.equip-card','.process-card','.price-card','.quote','.contact-info',
    '.contact-card','.care-card','.faq-list','.cta__inner','.stat'
  ];
  revealSelectors.forEach(selector=>{
    document.querySelectorAll(selector).forEach((el,index)=>{
      el.classList.add('js-reveal');
      el.style.transitionDelay=`${Math.min(index*55,330)}ms`;
    });
  });

  // Directional reveal for split content.
  document.querySelectorAll('.split-media').forEach(el=>el.classList.add('js-reveal--left'));
  document.querySelectorAll('.split-copy,.contact-card').forEach(el=>el.classList.add('js-reveal--right'));

  if('IntersectionObserver' in window){
    const io=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        if(entry.isIntersecting){
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    },{threshold:.14,rootMargin:'0px 0px -50px 0px'});
    document.querySelectorAll('.js-reveal').forEach(el=>io.observe(el));
  }else{
    document.querySelectorAll('.js-reveal').forEach(el=>el.classList.add('is-visible'));
  }

  // Header state + scroll progress.
  const header=document.querySelector('.site-header');
  let progress=document.querySelector('.aigle-scroll-progress');
  if(!progress){
    progress=document.createElement('div');
    progress.className='aigle-scroll-progress';
    progress.innerHTML='<span></span>';
    body.prepend(progress);
  }
  const bar=progress.querySelector('span');
  const onScroll=()=>{
    const scrollTop=window.scrollY||window.pageYOffset;
    if(header) header.classList.toggle('is-scrolled',scrollTop>24);
    const max=Math.max(document.documentElement.scrollHeight-window.innerHeight,1);
    if(bar) bar.style.width=`${Math.min(100,(scrollTop/max)*100)}%`;
  };
  onScroll();
  window.addEventListener('scroll',onScroll,{passive:true});

  // Lightweight number count-up for stats like 500+ and 25+.
  document.querySelectorAll('.stat__number').forEach(el=>{
    const original=el.textContent.trim();
    const match=original.match(/^(\d+)(.*)$/);
    if(!match) return;
    const target=parseInt(match[1],10);
    const suffix=match[2];
    el.dataset.target=String(target);
    el.dataset.suffix=suffix;
    el.textContent=`0${suffix}`;
    el.dataset.countReady='true';
  });

  if('IntersectionObserver' in window){
    const counterIO=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        if(!entry.isIntersecting) return;
        const el=entry.target;
        if(el.dataset.counted==='true') return;
        el.dataset.counted='true';
        const target=parseInt(el.dataset.target||'0',10);
        const suffix=el.dataset.suffix||'';
        const start=performance.now();
        const duration=1100;
        const tick=now=>{
          const p=Math.min((now-start)/duration,1);
          const eased=1-Math.pow(1-p,3);
          el.textContent=`${Math.round(target*eased)}${suffix}`;
          if(p<1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
        counterIO.unobserve(el);
      });
    },{threshold:.6});
    document.querySelectorAll('.stat__number[data-count-ready="true"]').forEach(el=>counterIO.observe(el));
  }

  // Floating call shortcut, only when a phone number is configured.
  const phoneLink=document.querySelector('.header-phone[href^="tel:"]');
  if(phoneLink && !document.querySelector('.aigle-floating-call')){
    const floating=document.createElement('a');
    floating.className='aigle-floating-call';
    floating.href=phoneLink.getAttribute('href');
    floating.setAttribute('aria-label','Call Aigle Dispatch');
    floating.innerHTML='<span class="aigle-floating-call__dot" aria-hidden="true"></span><span>Call Aigle Dispatch</span>';
    body.appendChild(floating);
  }
});
